import CssBaseline from '@mui/material/CssBaseline';
import AppTheme from '../shared-theme/AppTheme';
import AppAppBar from '.././components/AppAppBar';
import Hero from '.././components/Hero';
import LogoCollection from '.././components/LogoCollection';
import Footer from '.././components/Footer';

export default function Main(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />

      <AppAppBar />
      <Hero />
      <div>
        <LogoCollection />
        <Footer />
      </div>
    </AppTheme>
  );
}